export default __webpack_public_path__ + "static/media/Sql.4d993e2c.png";